<app-page>
  <app-page-title
    [title]="'INTEGRATIONS.OVERVIEW.TITLE' | translate"
  ></app-page-title>
  <div class="cards-container" *ngIf="integrations$ | async as integrations">
    <div class="card-content">
      <div class="info">
        <img class="logo" src="assets/img/webex-logo.jpg" />
        <div class="data">
          <div class="name">Webex Webinar</div>
          <div *ngIf="!(webexIntegration$ | async)" class="status">
            {{ "INTEGRATIONS.ACCOUNT-NOT-CONNECTED" | translate }}
          </div>
          <div
            *ngIf="webexIntegration$ | async as webexIntegration"
            class="status"
          >
            {{ "INTEGRATIONS.CONNECTED-TO" | translate }}:
            <b>{{ webexIntegration.displayName }}</b>
          </div>
        </div>
      </div>
      <dx-button
        *ngIf="!(webexIntegration$ | async)"
        type="normal"
        (click)="integrateWebex()"
      >
        {{ "INTEGRATIONS.CONNECT" | translate }}
      </dx-button>
      <dx-button
        *ngIf="webexIntegration$ | async"
        class="cta-btn"
        type="danger"
        (click)="showDisconnectModal('webex')"
      >
        {{ "INTEGRATIONS.DISCONNECT" | translate }}
      </dx-button>
    </div>
    <div class="card-content">
      <div class="info">
        <img class="logo" src="assets/img/gotowebinar-logo.jpg" />
        <div class="data">
          <div class="name">GoTo Webinar</div>
          <div *ngIf="!(goToWebinarIntegration$ | async)" class="status">
            {{ "INTEGRATIONS.ACCOUNT-NOT-CONNECTED" | translate }}
          </div>
          <div
            *ngIf="goToWebinarIntegration$ | async as goToWebinarIntegration"
            class="status"
          >
            {{ "INTEGRATIONS.CONNECTED-TO" | translate }}:
            <b>{{ goToWebinarIntegration.displayName }}</b>
          </div>
        </div>
      </div>
      <dx-button
        *ngIf="!(goToWebinarIntegration$ | async)"
        class="cta-btn"
        type="normal"
        (click)="integrateGoToWebinar()"
      >
        {{ "INTEGRATIONS.CONNECT" | translate }}
      </dx-button>
      <dx-button
        *ngIf="goToWebinarIntegration$ | async"
        class="cta-btn"
        type="danger"
        (click)="showDisconnectModal('gotowebinar')"
      >
        {{ "INTEGRATIONS.DISCONNECT" | translate }}
      </dx-button>
    </div>

    <!-- TEAMS Webinar -->
    <div class="card-content">
      <div class="info">
        <img class="logo" src="assets/img/teams-logo.png" />
        <div class="data">
          <div class="name">Teams Webinar</div>
          <div *ngIf="!(teamsIntegration$ | async)" class="status">
            {{ "INTEGRATIONS.ACCOUNT-NOT-CONNECTED" | translate }}
          </div>
          <div *ngIf="teamsIntegration$ | async as teamIntegration" class="status">
            {{ "INTEGRATIONS.CONNECTED-TO" | translate }}:
            <b>{{ teamIntegration.displayName }}</b>
          </div>
        </div>
      </div>
      <dx-button
        *ngIf="!(teamsIntegration$ | async)"
        class="cta-btn"
        type="normal"
        (click)="integrateTeamsWebinar()"
      >
        {{ "INTEGRATIONS.CONNECT" | translate }}
      </dx-button>
      <dx-button
        *ngIf="teamsIntegration$ | async"
        class="cta-btn"
        type="danger"
        (click)="showDisconnectModal('msTeams')"
      >
        {{ "INTEGRATIONS.DISCONNECT" | translate }}
      </dx-button>
    </div>

    <!-- TEAMS MEETINGS -->
    <div class="card-content">
      <div class="info">
        <img class="logo" src="assets/img/teams-logo.png" />
        <div class="data">
          <div class="name">Teams Meetings</div>
          <div *ngIf="!(teamsMeetingsIntegration$ | async)" class="status">
            {{ "INTEGRATIONS.ACCOUNT-NOT-CONNECTED" | translate }}
          </div>
          <div *ngIf="teamsMeetingsIntegration$ | async as teamIntegration" class="status">
            {{ "INTEGRATIONS.CONNECTED-TO" | translate }}:
            <b>{{ teamIntegration.displayName }}</b>
          </div>
        </div>
      </div>
      <dx-button
        *ngIf="!(teamsMeetingsIntegration$ | async)"
        class="cta-btn"
        type="normal"
        (click)="integrateTeamsMeetings()"
      >
        {{ "INTEGRATIONS.CONNECT" | translate }}
      </dx-button>
      <dx-button
        *ngIf="teamsMeetingsIntegration$ | async"
        class="cta-btn"
        type="danger"
        (click)="showDisconnectModal('msTeamsMeetings')"
      >
        {{ "INTEGRATIONS.DISCONNECT" | translate }}
      </dx-button>
    </div>

    <div class="card-content">
      <div class="info">
        <img class="logo" src="assets/img/zoom-logo.png" />
        <div class="data">
          <div class="name">Zoom Webinar</div>
          <div *ngIf="!(zoomIntegration$ | async)" class="status">
            {{ "INTEGRATIONS.ACCOUNT-NOT-CONNECTED" | translate }}
          </div>
          <div *ngIf="zoomIntegration$ | async as zoomIntegration" class="status">
            {{ "INTEGRATIONS.CONNECTED-TO" | translate }}:
            <b>{{ zoomIntegration.displayName }}</b>
          </div>
        </div>
      </div>
      <dx-button
        *ngIf="!(zoomIntegration$ | async)"
        class="cta-btn"
        type="normal"
        (click)="integrateZoom()"
      >
        {{ "INTEGRATIONS.CONNECT" | translate }}
      </dx-button>
      <dx-button
        *ngIf="zoomIntegration$ | async"
        class="cta-btn"
        type="danger"
        (click)="showDisconnectModal('zoom')"
      >
        {{ "INTEGRATIONS.DISCONNECT" | translate }}
      </dx-button>
    </div>

    <div class="card-content">
      <div class="info">
        <img class="logo" src="assets/img/gut-beraten-logo.png" />
        <div class="data">
          <div class="name">Gut beraten</div>
          <div *ngIf="!(wbdIntegration$ | async)" class="status">
            {{ "INTEGRATIONS.ACCOUNT-NOT-CONNECTED" | translate }}
          </div>
          <div *ngIf="wbdIntegration$ | async as wbdIntegration" class="status">
            {{ "INTEGRATIONS.CONNECTED" | translate }}
          </div>
        </div>
      </div>
      <dx-button
        *ngIf="!(wbdIntegration$ | async)"
        class="cta-btn"
        type="normal"
        (click)="showIntegrateWbd()"
      >
        {{ "INTEGRATIONS.CONNECT" | translate }}
      </dx-button>
      <dx-button
        *ngIf="wbdIntegration$ | async"
        class="cta-btn"
        type="danger"
        (click)="showDisconnectModal('gutberaten')"
      >
        {{ "INTEGRATIONS.DISCONNECT" | translate }}
      </dx-button>
    </div>
  </div>
</app-page>

<dx-popup
  [height]="'auto'"
  [maxWidth]="550"
  [hideOnOutsideClick]="true"
  [showCloseButton]="true"
  [(visible)]="disconnectModalVisible"
  [title]="'INTEGRATIONS.ATTENTION' | translate"
  [dragEnabled]="false"
  [wrapperAttr]="{ class: 'disconnect-modal' }"
>
  <div *dxTemplate="let data of 'content'" class="modal-template">
    <div class="disconnect-modal-copy">
      {{
        disconnectType == "gutberaten"
          ? ("INTEGRATIONS.DISCONNECT-WBD-CONFIRMATION" | translate)
          : ("INTEGRATIONS.DISCONNECT-CONFIRMATION" | translate)
      }}
    </div>
    <div class="disconnect-modal-cta">
      <dx-button class="cta-btn" type="normal" (click)="closeDisconnectModal()">
        {{ "COMMON.CANCEL" | translate }}
      </dx-button>
      <dx-button
        class="cta-btn"
        type="danger"
        (click)="disconnectIntegration()"
      >
        {{ "INTEGRATIONS.DISCONNECT" | translate }}
      </dx-button>
    </div>
  </div>

</dx-popup>
<app-integrate-wbd-modal
  *ngIf="showIntegrateWbdModal"
  [(showModal)]="showIntegrateWbdModal"
  (submit)="integrateWbd($event)"
></app-integrate-wbd-modal>
